export default function system(state = {}) {
  return state;
}
